(function () {
  'use strict';

  var source = 'strive-to-be.com';
  var formNames = {
    '1db44ce1-2424-4750-8514-69290735341b': 'Request a Quote',
    'bcbadc62-7375-4bed-a00a-62683934bf70': 'Contact Form',
    'b1dca11c-67eb-47cb-a9f3-f6ae7c70cedc': 'Launch a Team Store'
  };
  var completedInstances = {};

  function emit(event, properties) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: event,
      source: source,
      occurred_at: new Date().toISOString(),
      properties: properties || {}
    });
  }

  function formProperties(formId, instanceId) {
    return {
      form_id: formId || 'unknown',
      form_name: formNames[formId] || 'unknown',
      instance_id: instanceId || 'unknown',
      business_unit: 'Strive-To-Be',
      page: window.location.pathname
    };
  }

  window.STBRevenue = {
    emit: emit,
    catalog: function () { return window.STBCanonicalCatalog || []; },
    renderProducts: function (target, products) {
      if (!target || !Array.isArray(products)) return;
      target.dispatchEvent(new CustomEvent('stb:catalog-ready', {
        detail: { products: products, source: source }
      }));
    },
    submitQuote: function (request) {
      emit('revenue_quote_request', {
        form_id: request.formId || 'unknown',
        product_ids: (request.items || []).map(function (item) { return item.productId; }),
        tier_selection: request.tierSelection || null,
        package_id: request.packageId || null,
        quote_value: request.quoteValue || null
      });
      return {
        source: source,
        customer: request.customer,
        items: request.items || [],
        packageId: request.packageId || null,
        tierSelection: request.tierSelection || null,
        notes: request.notes || ''
      };
    }
  };

  window.addEventListener('hs-form-event:on-submission:success', function (event) {
    var detail = event.detail || {};
    var key = detail.instanceId || detail.formId;
    if (completedInstances[key]) return;
    completedInstances[key] = true;
    emit('revenue_form_submitted', formProperties(detail.formId, detail.instanceId));
  });

  window.addEventListener('hs-form-event:on-submission:failed', function (event) {
    var detail = event.detail || {};
    emit('revenue_form_submission_failed', formProperties(detail.formId, detail.instanceId));
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a');
    if (!link) return;
    if (link.href.startsWith('tel:')) emit('revenue_phone_click', { page: location.pathname });
    if (link.href.startsWith('mailto:')) emit('revenue_email_click', { page: location.pathname });
    if (link.hasAttribute('download')) emit('revenue_download', { asset_id: link.getAttribute('href') });
  });

  document.querySelectorAll('[data-revenue-products]').forEach(function (element) {
    element.setAttribute('aria-busy', 'false');
  });
  emit('revenue_catalog_ready', {
    product_count: (window.STBCanonicalCatalog || []).length,
    catalog_version: 'Catalog-v1.0'
  });
}());
